import React from 'react';
import haWrapper from '../../utils/haWrapper';
import {sendCustomAnalytics} from '../../utils/loadTimeAnalyticsWrapper';

const withTiming = (measureName) => (WrappedComponent) => {
    let namedWrappedComponent = class extends React.Component {
        constructor(props) {
            super(props);
            haWrapper.userTiming.mark(`${measureName}_start`);
        }

        componentDidMount() {
            haWrapper.userTiming.mark(`${measureName}_end`);
            haWrapper.userTiming.measureAndSend(
                measureName,
                `${measureName}_start`,
                `${measureName}_end`
            );
            sendCustomAnalytics(measureName, 'measure', (analytics) => ({
                [`${measureName}DurationTime`]: analytics.duration,
                [`${measureName}StartTime`]: analytics.startTime
            }));
        }

        componentWillUnmount() {
            haWrapper.userTiming.clearMarks(`${measureName}_start`);
            haWrapper.userTiming.clearMarks(`${measureName}_end`);
            haWrapper.userTiming.clearMeasures(measureName);
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    /* istanbul ignore next */
    namedWrappedComponent.displayName = `withTiming(${WrappedComponent.displayName ||
        WrappedComponent.name ||
        'Component'})`;
    return namedWrappedComponent;
};
export default withTiming;
